import React, { forwardRef } from 'react';
import cn from 'classnames';
import { PaginationVariantProps } from '../../types';

import ArrowButton from './ArrowButton';

const Banner = forwardRef<HTMLDivElement, PaginationVariantProps>(
  (
    {
      currentPage = 1,
      totalPages = 1,
      onPrev,
      onNext,
      dark,
      className,
      ...other
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={cn('flex flex-col items-center', className)}
      {...other}
    >
      <p className="mb-16 font-gil text-16 leading-20 tracking-4 flex items-center justify-center text-center text-white">
        <span className="font-bold mr-4">{`${
          currentPage.toString().length < 2 ? 0 : ''
        }${currentPage}`}</span>
        {`/ ${totalPages.toString().length < 2 ? 0 : ''}${totalPages}`}
      </p>
      <ArrowButton
        direction="left"
        disabled={currentPage <= 1}
        onClick={onPrev}
        dark={dark}
      />
      <ArrowButton
        direction="right"
        disabled={currentPage >= totalPages}
        onClick={onNext}
        dark={dark}
      />
    </div>
  ),
);

export default Banner;
